import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-charity-efforts',
  templateUrl: './charity-efforts.component.html',
  styleUrls: ['./charity-efforts.component.css']
})
export class CharityEffortsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
